/**
 * 判断一个值是否为NaN
 * @param {number | string} value
 * @return {boolean}
 */
export function myIsNaN(value) {
  if (typeof value !== "number" && typeof value !== "string") {
    return true;
  }
  if (typeof value === "string" && "" === value.trim()) {
    // 判断空格
    return true;
  }
  let n = Number(value);
  return n !== n;
}

// 密码规则
/**
 * @param {number | string} password
 * @return {object: Error}
 */
export function passwordRules(password) {
  const regex = /^\w{6,18}$/;
  if (!password) {
    return {
      success: false,
      msg: window._I18N.t("login.password-empty-tips")
    };
  }
  if (password.length < 6 || password.length > 18) {
    return {
      success: false,
      msg: window._I18N.t("login.pwd-length")
    };
  }
  if (!regex.test(password)) {
    return {
      success: false,
      msg: window._I18N.t("login.pwd-combined")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 马来手机号规则
/**
 * @param {number | string} mobile
 * @return {object: Error}
 */
export function mobileRules(mobile) {
  const regex = /^\w{0,20}$/;
  if (!mobile) {
    return {
      success: false,
      msg: window._I18N.t("login.input-mobile-number")
    };
  }
  if (mobile.length > 20) {
    return {
      success: false,
      msg: window._I18N.t("login.mobile-length")
    };
  }
  if (!regex.test(mobile)) {
    return {
      success: false,
      msg: window._I18N.t("login.mobile-format")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 邮箱规则
/**
 * @param {string} mail
 * @return {object: Error}
 */
export function mailRules(mail) {
  const regex = /^([a-zA-Z\d])(\w|-|.)*@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/;
  if (!mail) {
    return {
      success: false,
      msg: window._I18N.t("base.input-email")
    };
  }
  if (!regex.test(mail)) {
    return {
      success: false,
      msg: window._I18N.t("base.correct-email")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

/**
 * 价格规则
 * 正数价格
 * @param {number | string} price
 * @return {object: Error}
 */
export function priceRules(price) {
  const regex = /^[0-9]+(.[0-9]+)?$/;
  price = String(price);
  if (!regex.test(price)) {
    return {
      success: false,
      msg: window._I18N.t("base.input-positive-number")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

/**
 * 用户名规则
 * @param { string} username
 * @return {object: Error}
 */
export function usernameRules(price) {
  const regex = /^([0-9]|[a-z]|[A-Z]|_){6,18}$/;
  price = String(price);
  if (!regex.test(price)) {
    return {
      success: false,
      msg: window._I18N.t("login.userName-format")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

/**
 * 验证正整数
 * @param {number | string} num
 * @return {boolean: result}
 */
export function isPositiveInteger(num) {
  const regex = /^\d+$/;
  if (regex.test(num) && num > 0) {
    return true;
  }
  return false;
}

/**
 * 零配件数量规则
 * 大于等于0 可以为小数，保留1位小数点
 * @param {number | string} quantity
 * @return {object: Error}
 */
export function partsQuantityRules(quantity) {
  const regex = /^[0-9]+(.[0-9]{1})?$/;
  quantity = String(quantity);
  if (!regex.test(quantity)) {
    return {
      success: false,
      msg: window._I18N.t("setting.associated-number")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

/**
 * 工时正则：非负整数||0
 * @param {number | string} workHour
 * @return {object: Error}
 */
export function workHourRules(workHour) {
  if (Number(workHour) !== 0 && !isPositiveInteger(workHour)) {
    return {
      success: false,
      msg: window._I18N.t("base.input-positive-integer")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 身份证规则
/**
 * @param {string} id
 * @return {object: Error}
 */
export function checkIdentityId(id) {
  const regex = /^([0-9]|[a-z]|[A-Z])*$/;
  if (!regex.test(id)) {
    return {
      success: false,
      msg: window._I18N.t("base.correct-ID-card")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 车牌号
/**
 * @param {string} code
 * @return {object: Error}
 */
export function checkPlateCode(code) {
  const regex = /^([0-9]|[a-z]|[A-Z])*$/;
  if (!code || code.length <= 1) {
    // 省会缩写占用一个长度
    return {
      success: false,
      msg: window._I18N.t("test.enter-license")
    };
  }
  const plateNum = code.substr(1);
  if (!regex.test(plateNum)) {
    return {
      success: false,
      msg: window._I18N.t("test.correct-car-number")
    };
  }
  return {
    success: true,
    msg: ""
  };
}

// 密码规则配合el-form使用
/**
 * @param {number | string} password
 * @param {Element:callback} callback
 */
export function passwordRulesEl(password, callback) {
  let match = passwordRules(password);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 手机规则配合el-form使用
/**
 * @param {number | string} mobile
 * @param {Element:callback} callback
 */
export function mobileRulesEl(mobile, callback) {
  let match = mobileRules(mobile);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 邮箱规则配合el-form使用
/**
 * @param {number | string} mail
 * @param {Element:callback} callback
 */
export function mailRulesEl(mail, callback) {
  let match = mailRules(mail);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 价格配合el-form使用
/**
 * @param {number | string} price
 * @param {Element:callback} callback
 */
export function priceRulesEl(price, callback) {
  let match = priceRules(price);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 身份证号校验配合el-form使用
/**
 * @param {number | string} price
 * @param {Element:callback} callback
 */
export function identityIdRulesEl(id, callback) {
  let match = checkIdentityId(id);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

// 身份证号校验配合el-form使用
/**
 * @param {number | string} plateCode
 * @param {Element:callback} callback
 */
export function plateCodeRuleEl(plateCode, callback) {
  let match = checkPlateCode(plateCode);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}

/**用户名
 * @param {number | string} username
 * @param {Element:callback} callback
 */
export function usernameRuleEl(username, callback) {
  let match = usernameRules(username);
  if (match.success) {
    callback();
  } else {
    callback(new Error(match.msg));
  }
}
